import featureManager from './FeatureManager';

export { Feature, MultivariateFeature } from './constants';
export default featureManager;
